import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EsqueciComponent } from './routes/esqueci/esqueci.component';
import { HomeComponent } from './routes/home/home.component';
import { RecuperaComponent } from './routes/recupera/recupera.component';
import { LoginCelularComponent } from './routes/login-celular/login-celular.component';

const routes: Routes = [{
  path: "",
  pathMatch: "full",
  component: HomeComponent,
  canActivate: []
},{
  path: "esqueci",
  component: EsqueciComponent
},{
  path: "recupera",
  component: RecuperaComponent
},{
  path: "login-celular",
  component: LoginCelularComponent
},{
  path: "**",
  redirectTo: ""
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
